/*
 * @Author: Lemon C
 * @Date: 2024-06-18 16:40:11
 * @LastEditTime: 2025-01-07 14:55:45
 */
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useMessageStore = defineStore('message', () => {
    const messageObj = ref({});
    const M_E_NAV_SCROLL = 'msg_event_navControl_listen_scroll'; //顶部导航页面滚动---监听消息
    const M_E_TREE_AUTO_SEL = 'msg_event_tree_auto_sel_node'; //目录树自动滚动目标节点---监听消息
    const M_E_TREE_LIST_UPDATE = 'msg_event_tree_list_update'; //目录树数据更新---监听消息
    const M_E_SCROLL_TOP = 'msg_event_scroll_top'; //页面滚动到顶部---监听消息
    const M_E_SCROLL_ANCHOR = 'msg_event_scroll_anchor'; //文档滚动锚点联动---监听消息

    // MARK 发送消息
    const sendMessage = (messageName, payload) => {
        if (!messageName || !messageObj.value || !messageObj.value[messageName]) {
            return;
        }
        messageObj.value[messageName].handlers.forEach((handler) => handler(payload));
    };

    // MARK 注册消息
    const addMessageHandler = (messageName, handler) => {
        if (!messageName || !messageObj.value) return;
        if (!messageObj.value[messageName]) {
            messageObj.value[messageName] = {
                handlers: [],
            };
        }
        messageObj.value[messageName].handlers.push(handler);
    };

    // MARK 移除消息
    const removeMessageHandler = (messageName, handler) => {
        if (!messageName || !messageObj.value || !messageObj.value[messageName]) return;
        messageObj.value[messageName].handlers = messageObj.value[messageName].handlers.filter((h) => h !== handler);
    };

    // MARK 导出
    return {
        M_E_NAV_SCROLL,
        M_E_TREE_AUTO_SEL,
        M_E_TREE_LIST_UPDATE,
        M_E_SCROLL_TOP,
        M_E_SCROLL_ANCHOR,
        sendMessage,
        addMessageHandler,
        removeMessageHandler,
    };
});
